import { readScopesEnabled } from "@/api";
import { useContext } from "react";

import { OrganizationContext } from "./OrganizationContext";

/**
 * Whether the org may see Scopes and Comparisons.
 *
 * Context-optional, unlike `useOrganization`: hosts mounted outside
 * `OrganizationProvider` — stories, tests and the menu-mounted move modal —
 * read as enabled rather than throwing, so the single default-on policy lives
 * here instead of in each caller's props.
 */
export function useScopesEnabled(): boolean {
    return readScopesEnabled(useContext(OrganizationContext)?.settings);
}
